﻿import { createElement } from "./_dom";
import { createBigSpinner } from "./spinner";

function renderLocationMapImage(img) {
	function patchURL(mapURL) {
		const userGoogleMapApiKey = window.GoogleMapApiKey;
		if (userGoogleMapApiKey) {
			const mapUrlObj = new URL(mapURL);
			mapUrlObj.searchParams.delete("signature");
			mapUrlObj.searchParams.set("key", userGoogleMapApiKey);
			mapURL = mapUrlObj.toString();
		}
		return mapURL;
	}
	const srcset = img.dataset.srcset;
	const src = img.dataset.src;
	img.removeAttribute("data-srcset");
	img.removeAttribute("data-src");
	img.classList.add("v3-state-busy");
	img.srcset = srcset.split(' ').map(patchURL).join(' ');
	img.src = patchURL(src);
	img.onerror = img.onload = function () { this.classList.remove("v3-state-busy"); };
}

function loadLocationMapWhenVisible(entries, observer) {
	entries.forEach(({ isIntersecting, target: img }) => {
		if (isIntersecting) {
			observer.unobserve(img);
			renderLocationMapImage(img);
		}
	});
}

function renderMapView(mapView) {
	const width = mapView.offsetWidth;
	const height = mapView.offsetHeight;
	const uri = new URL(mapView.href);
	const top = mapView.dataset.staticMapTop;
	uri.searchParams.set("top", top);
	uri.searchParams.set("map.w", width);
	uri.searchParams.set("map.h", height);
	if (window.GoogleMapApiKey) {
		uri.searchParams.set("map.k", window.GoogleMapApiKey);
	}
	mapView.setAttribute("aria-busy", "true");
	const spinner = createBigSpinner();
	mapView.replaceChildren(spinner);
	const image = createElement("img", {
		class: "v3-staticmapview__image",
		src: `${uri}&map.s=1`,
		srcset: [1, 2, 4].map(n => { uri.searchParams.set("map.s", n); return `${uri} ${n}x`; }).join(","),
	});
	image.decode().then(() => {
		mapView.setAttribute("aria-busy", "false");
		mapView.replaceChildren(image);
	}).catch(e => {
		const errorBox = createElement("p", { class: "v3-layout__error v3-error" }, e.message || e.toString());
		mapView.setAttribute("aria-busy", "false");
		mapView.replaceChildren(errorBox);
	});
}

function loadStaticMapWhenVisible(entries, observer) {
	entries.forEach(({ isIntersecting, target: mapView }) => {
		if (isIntersecting) {
			observer.unobserve(mapView);
			renderMapView(mapView);
		}
	});
}

let locationMapImageObserver;

function renderLocationMaps(context, selector = ".v3-location-link__image[data-srcset]") {
	locationMapImageObserver ??= new IntersectionObserver(loadLocationMapWhenVisible);
	context.querySelectorAll(selector).forEach(el => locationMapImageObserver.observe(el));
}

let staticMapViewObserver;

function renderStaticMapViews(context, selector = ".v3-staticmapview") {
	staticMapViewObserver ??= new IntersectionObserver(loadStaticMapWhenVisible);
	context.querySelectorAll(selector).forEach(c => staticMapViewObserver.observe(c));
}

function init(context) {
	renderLocationMaps(context);
	renderStaticMapViews(context);
}

export { init };
